import { render, staticRenderFns } from "./perManagement.vue?vue&type=template&id=74977718&"
import script from "./perManagement.vue?vue&type=script&lang=js&"
export * from "./perManagement.vue?vue&type=script&lang=js&"
import style0 from "./perManagement.vue?vue&type=style&index=0&id=74977718&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports